import axios from 'axios'
import Qs from 'qs'

const apiClient = axios.create({
    // create single axios instance for entire app
    baseURL: '/', // base URL to call
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
})

export default {
    sendError (data) {
        return apiClient.post('etermin-error', Qs.stringify({
            error: data
        }))
    },
    sendCreation(data){
        return apiClient.post('etermin-creation', Qs.stringify({
            data: data
        }))
    }
}
